/** Label3D property formatter: the inspector sections for a label. */
import { formatColorRgba } from '../../../utils/colorParser';
import { formatNode3DProperties } from '../../base/node3d/propertyFormatter';
import { billboardName } from '../sprites/shared/billboardName';
export function formatLabel3DProperties(properties) {
    const sections = [];
    const textItems = [
        { label: 'Text', value: properties.text || '(empty)' },
        { label: 'Pixel Size', value: properties.pixel_size.toFixed(4) },
        { label: 'Billboard', value: billboardName(properties.billboard) },
    ];
    sections.push({
        title: 'Text',
        items: textItems,
    });
    const colorItems = [
        {
            label: 'Modulate',
            value: formatColorRgba(properties.modulate),
        },
    ];
    sections.push({
        title: 'Color',
        items: colorItems,
    });
    if (properties.outline_size > 0) {
        const outlineItems = [
            { label: 'Outline Size', value: properties.outline_size.toFixed(0) },
            {
                label: 'Outline Color',
                value: formatColorRgba(properties.outline_modulate),
            },
        ];
        sections.push({
            title: 'Outline',
            items: outlineItems,
        });
    }
    sections.push(...formatNode3DProperties(properties));
    return sections;
}
//# sourceMappingURL=propertyFormatter.js.map